import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';

@Component({
  selector: 'app-activities-sms-consumption-card',
  templateUrl: './activities-sms-consumption-card.component.html',
  styleUrls: ['./activities-sms-consumption-card.component.scss']
})
export class ActivitiesSmsConsumptionCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('sms-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('sms-counts-spinner');
      this.showCounter = true;
      this.count = this.data.length;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('sms-counts-spinner');
    }
  }
}
